(function() {
  var VAT_LABEL_CART = ' exc. VAT | ';
  var cartTotalSelectors = [
    '.cart__footer',
    '.cart-drawer__footer',
    '.cart-drawer__content',
    '[data-subtotal]',
    '.totals',
    '.cart__subtotal',
    '[data-bss-keep-vat-label]'
  ];

  function isInCartTotal(el) {
    return cartTotalSelectors.some(function(sel) {
      return el.closest && el.closest(sel);
    });
  }

  function patchBssTranslations() {
    try {
      if (typeof BSS_B2B === 'undefined' || !BSS_B2B.td) return false;
      var td = BSS_B2B.td;
      if (!td.tdTranslations) return false;
      if (td.tdTranslations.excluded_vat_text === '') return true;
      td.tdTranslations.excluded_vat_text = '';
      return true;
    } catch (e) {
      return false;
    }
  }

  function addVatLabelInCartTotal() {
    document.querySelectorAll('.bss-b2b-price-no-vat').forEach(function(span) {
      if (!isInCartTotal(span)) return;
      var t = span.textContent.trim();
      if (t && t.indexOf('exc.') === -1 && t.indexOf('VAT') === -1) {
        span.textContent = t + VAT_LABEL_CART;
      }
    });
  }

  function cleanExistingNonCart() {
    document.querySelectorAll('.bss-b2b-price-no-vat').forEach(function(span) {
      if (isInCartTotal(span)) return;
      var text = span.textContent;
      var cleaned = text.replace(/\s*exc\.\s*VAT\s*\|\s*/gi, '');
      if (cleaned !== text) span.textContent = cleaned;
    });
  }

  function removeEaFromPrices() {
    function stripEa(el) {
      if (isInCartTotal(el)) return;
      var text = el.textContent;
      var cleaned = text.replace(/\s*\/ea\s*/gi, '').replace(/\s*\/ciascuno\s*/gi, '');
      if (cleaned !== text) el.textContent = cleaned;
    }
    document.querySelectorAll('.bss-b2b-price-no-vat').forEach(stripEa);
    document.querySelectorAll('[bss-b2b-product-price], [bss-b2b-variant-price]').forEach(stripEa);
    document.querySelectorAll('.quick-add-modal__content .price, .quick-add-modal__content-info--bulk .price').forEach(stripEa);
  }

  function runOnModalOpen() {
    removeEaFromPrices();
  }

  function isModalBulkOpen() {
    var el = document.querySelector('.quick-add-modal__content--bulk, .quick-add-modal__content-info--bulk');
    return el && el.offsetParent !== null;
  }

  function cleanPlaceholderContent(placeholder) {
    if (!placeholder || !placeholder.querySelectorAll) return;
    placeholder.querySelectorAll('.bss-b2b-price-no-vat, [bss-b2b-product-price], .price-item').forEach(function(el) {
      if (isInCartTotal(el)) return;
      var text = el.textContent;
      var cleaned = text.replace(/\s*exc\.\s*VAT\s*\|\s*/gi, '').replace(/\s*\/ea\s*/gi, '');
      if (cleaned !== text) el.textContent = cleaned;
    });
  }

  function getCardPriceForProduct(productId) {
    var cardPriceEl = document.querySelector('.card-wrapper [bss-b2b-product-id="' + productId + '"]');
    if (!cardPriceEl || cardPriceEl.closest('.quick-add-modal__content')) return null;
    var noVat = cardPriceEl.querySelector ? cardPriceEl.querySelector('.bss-b2b-price-no-vat') : null;
    if (noVat) return { text: noVat.textContent.trim(), html: (cardPriceEl.closest('.price') || cardPriceEl).innerHTML };
    var container = cardPriceEl.closest('.price') || cardPriceEl.closest('.price__container') || cardPriceEl;
    return { text: container.textContent.trim(), html: container.innerHTML };
  }

  function parsePriceToNumber(priceStr) {
    if (!priceStr || typeof priceStr !== 'string') return 0;
    var s = priceStr.split('/')[0]; // ← AGGIUNGI QUESTA RIGA
    s = s.replace(/\s/g, '').replace(/[^\d,.\-]/g, '');
    if (!s) return 0;
    var hasComma = s.indexOf(',') !== -1;
    var hasDot = s.indexOf('.') !== -1;
    if (hasComma && hasDot) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (hasComma) {
      s = s.replace(',', '.');
    }
    return parseFloat(s) || 0;
  }

  function formatPriceEur(amount) {
    var n = Number(amount);
    if (isNaN(n)) return '€0,00';
    var fixed = n.toFixed(2);
    var parts = fixed.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + intPart + ',' + (parts[1] || '00');
  }

  function setCellPrice(cell, formatted) {
    if (!cell) return;
    var priceWrap = cell.querySelector('.price');
    var target = cell.querySelector('.bss-b2b-price-no-vat, .price-item, [bss-b2b-variant-price], [bss-b2b-final-line-price]');
    if (target) {
      target.textContent = formatted;
      if (priceWrap && priceWrap !== target) {
        var inner = priceWrap.querySelector('.bss-b2b-price-no-vat');
        if (inner && inner !== target) inner.textContent = formatted;
      }
      tidyVariantTotalCell(cell);
    } else {
      var span = cell.querySelector('.price .bss-b2b-price-no-vat, .price span');
      if (span) {
        span.textContent = formatted;
        tidyVariantTotalCell(cell);
      } else {
        cell.textContent = '';
        var wrap = document.createElement('span');
        wrap.className = 'price';
        var inner = document.createElement('span');
        inner.className = 'bss-b2b-price-no-vat';
        inner.textContent = formatted;
        wrap.appendChild(inner);
        cell.appendChild(wrap);
      }
    }
  }

  function tidyVariantTotalCell(cell) {
    if (!cell) return;
    var spinner = cell.querySelector('.loading__spinner');
    if (spinner && !spinner.classList.contains('hidden')) spinner.classList.add('hidden');
    var priceEl = cell.querySelector('.bss-b2b-price-no-vat');
    if (priceEl) {
      var directText = [];
      for (var i = 0; i < cell.childNodes.length; i++) {
        var n = cell.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) directText.push(n);
      }
      directText.forEach(function(n) { n.remove(); });
    }
  }

  function recalcModalTotalsExclVat(modalRoot, productId, unitPriceExclVatNum) {
    if (!modalRoot || unitPriceExclVatNum <= 0) return;
    var bulkEl = modalRoot.querySelector('bulk-modal[data-bss-recalc-totals]') || modalRoot.querySelector('bulk-modal') || modalRoot;
    var totalSum = 0;
    var qtyInputs = bulkEl.querySelectorAll('input[type="number"]');
    qtyInputs.forEach(function(qtyInput) {
      var row = qtyInput.closest('tr.variant-item');
      if (!row) return;
      var qty = parseInt(qtyInput.value, 10) || 0;

      var rawPrice = row.getAttribute('data-price-excl-vat');
      var isTurum  = row.hasAttribute('data-turum');

      var rowUnitPrice = rawPrice
        ? (isTurum
            ? parseFloat(rawPrice) / 100           // già excl VAT dal Liquid, solo /100
            : Math.round(parseFloat(rawPrice) / 1.22) / 100)  // lordo → netto
        : unitPriceExclVatNum;
          
      // ← AGGIUNGI QUI: aggiorna cella prezzo unitario
      var unitPriceCell = row.querySelector('.variant-item__price');
      if (unitPriceCell) {
        var formattedUnit = formatPriceEur(rowUnitPrice);
        var target = unitPriceCell.querySelector('.bss-b2b-price-no-vat, .price-item, .price span');
        if (target) {
          target.textContent = formattedUnit;
        } else {
          var priceSpan = unitPriceCell.querySelector('.price');
          if (priceSpan) priceSpan.innerHTML = '<span class="bss-b2b-price-no-vat">' + formattedUnit + '</span>';
        }
      }

      var lineTotal = qty * rowUnitPrice;
      totalSum += lineTotal;
      var formatted = formatPriceEur(lineTotal);
      var desktopTotal = row.querySelector('.variant-item__totals.small-hide.medium-hide, td.variant-item__totals:last-of-type');
      var mobileTotal = row.querySelector('.variant-item__totals.large-up-hide');
      if (desktopTotal) {
        desktopTotal.setAttribute('data-bss-line-total', '');
        setCellPrice(desktopTotal, formatted);
      }
      if (mobileTotal) setCellPrice(mobileTotal, formatted);
    });
    var grandTotalEl = bulkEl.querySelector('[data-bss-modal-total]') || bulkEl.querySelector('.totals__subtotal-value') || bulkEl.querySelector('.quick-order-list-total__price .totals__subtotal-value') || bulkEl.querySelector('tfoot td, .totals__total, [data-subtotal]');
    if (grandTotalEl) {
      grandTotalEl.setAttribute('data-bss-modal-total', '');
      var formattedTotal = formatPriceEur(totalSum);
      var totalTarget = grandTotalEl.querySelector('.bss-b2b-price-no-vat, .price-item, [bss-b2b-product-price], [bss-b2b-cart-total-price]');
      if (totalTarget) {
        if (totalTarget.textContent.trim() !== formattedTotal) totalTarget.textContent = formattedTotal;
      } else if (grandTotalEl.classList && grandTotalEl.classList.contains('totals__subtotal-value')) {
        if (grandTotalEl.textContent.trim() !== formattedTotal) grandTotalEl.textContent = formattedTotal;
      } else {
        var subVal = grandTotalEl.querySelector('.totals__subtotal-value');
        if (subVal && subVal.textContent.trim() !== formattedTotal) subVal.textContent = formattedTotal;
        else if (grandTotalEl.textContent.trim() !== formattedTotal) grandTotalEl.textContent = formattedTotal;
      }
    }
  }

  function forceModalPricesToExclVat(modalRoot, productId, cardPrice) {
    if (!cardPrice || !modalRoot) return;
    var text = cardPrice.text;
    var html = cardPrice.html;
    modalRoot.querySelectorAll('.quick-add-modal__price-placeholder[data-product-id]').forEach(function(ph) {
      if (ph.getAttribute('data-product-id') === productId && ph.innerHTML !== html) ph.innerHTML = html;
    });
    modalRoot.querySelectorAll('.bss-b2b-price-no-vat').forEach(function(span) {
      if (span.textContent.trim() !== text) span.textContent = text;
    });
    modalRoot.querySelectorAll('[bss-b2b-product-price]').forEach(function(el) {
      var inner = el.querySelector('.bss-b2b-price-no-vat');
      if (inner) {
        if (inner.textContent.trim() !== text) inner.textContent = text;
      } else {
        if (el.textContent.trim() !== text) el.innerHTML = '<span class="bss-b2b-price-no-vat">' + text + '</span>';
      }
    });
    modalRoot.querySelectorAll('.price').forEach(function(el) {
      if (el.closest('.quick-add-modal__price-placeholder')) return;
      // AGGIUNGI questo check:
      if (el.closest('tr.variant-item')) return;
      var noVat = el.querySelector('.bss-b2b-price-no-vat');
      if (noVat) {
        if (noVat.textContent.trim() !== text) noVat.textContent = text;
      } else {
        el.innerHTML = '<span class="bss-b2b-price-no-vat">' + text + '</span>';
      }
    });
    var unitPriceNum = parsePriceToNumber(text);
    recalcModalTotalsExclVat(modalRoot, productId, unitPriceNum);
  }

  function syncModalPriceFromCard() {
    var modalRoots = document.querySelectorAll('.quick-add-modal__content');
    modalRoots.forEach(function(modalRoot) {
      var placeholders = modalRoot.querySelectorAll('.quick-add-modal__price-placeholder[data-product-id]');
      placeholders.forEach(function(placeholder) {
        var productId = placeholder.getAttribute('data-product-id');
        if (!productId) return;
        var cardPrice = getCardPriceForProduct(productId);
        if (!cardPrice) return;
        if (placeholder.innerHTML !== cardPrice.html) placeholder.innerHTML = cardPrice.html;
        cleanPlaceholderContent(placeholder);
        forceModalPricesToExclVat(modalRoot, productId, cardPrice);
      });
    });
  }

  var modalSyncFastInterval = null;
  function startModalSyncWhenOpen() {
    if (!isModalBulkOpen()) {
      if (modalSyncFastInterval) {
        clearInterval(modalSyncFastInterval);
        modalSyncFastInterval = null;
      }
      return;
    }
    if (modalSyncFastInterval) return;
    modalSyncFastInterval = setInterval(function() {
      if (!isModalBulkOpen()) {
        clearInterval(modalSyncFastInterval);
        modalSyncFastInterval = null;
        return;
      }
      syncModalPriceFromCard();
    }, 400);
  }

  function injectQuickOrderTableStyles() {
    if (document.getElementById('bss-quick-order-variant-total-styles')) return;
    var style = document.createElement('style');
    style.id = 'bss-quick-order-variant-total-styles';
    style.textContent = [
      '.quick-order-list__table .variant-item__totals.small-hide.medium-hide, .quick-order-list__table .variant-item__totals.large-up-hide {',
      '  text-align: right; white-space: nowrap; min-width: 5.5em;',
      '}',
      '.quick-order-list__table .variant-item__totals .price { display: block; }',
      '.quick-order-list__table .variant-item__totals .loading__spinner.hidden { display: none !important; }',
      '.quick-order-list__table thead th:last-of-type { text-align: right; min-width: 5.5em; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function init() {
    if (!patchBssTranslations()) return false;
    injectQuickOrderTableStyles();
    cleanExistingNonCart();
    removeEaFromPrices();
    addVatLabelInCartTotal();
    return true;
  }

  function run() {
    if (init()) {
      addVatLabelInCartTotal();
    }
  }

  function waitBssThenRun() {
    var attempts = 0;
    var maxAttempts = 50;
    var t = setInterval(function() {
      attempts++;
      if (patchBssTranslations()) {
        clearInterval(t);
        cleanExistingNonCart();
        removeEaFromPrices();
        addVatLabelInCartTotal();
        setInterval(function() {
          addVatLabelInCartTotal();
          removeEaFromPrices();
          syncModalPriceFromCard();
          startModalSyncWhenOpen();
        }, 2500);
      } else if (attempts >= maxAttempts) {
        clearInterval(t);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitBssThenRun);
  } else {
    waitBssThenRun();
  }
  window.addEventListener('load', function() {
    run();
    setTimeout(addVatLabelInCartTotal, 1000);
  });
  document.addEventListener('shopify:section:load', run);

  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('.quick-add button[aria-haspopup="dialog"]');
    if (btn) {
      [400, 800, 1200, 2000, 3000, 4500, 6000].forEach(function(ms) {
        setTimeout(function() {
          syncModalPriceFromCard();
          startModalSyncWhenOpen();
        }, ms);
      });
    }
  });

  document.addEventListener('input', function(e) {
    var input = e.target;
    if (input.type !== 'number') return;
    var modal = input.closest && input.closest('.quick-add-modal__content');
    if (!modal) return;
    var unitPriceEl = modal.querySelector('.bss-b2b-price-no-vat, .quick-add-modal__price-placeholder .bss-b2b-price-no-vat');
    if (!unitPriceEl) return;
    var productId = modal.querySelector('.quick-add-modal__price-placeholder') && modal.querySelector('.quick-add-modal__price-placeholder').getAttribute('data-product-id');
    var unitNum = parsePriceToNumber(unitPriceEl.textContent);
    recalcModalTotalsExclVat(modal, productId, unitNum);
  }, true);
  document.addEventListener('change', function(e) {
    var input = e.target;
    if (input.type !== 'number') return;
    var modal = input.closest && input.closest('.quick-add-modal__content');
    if (!modal) return;
    var unitPriceEl = modal.querySelector('.bss-b2b-price-no-vat, .quick-add-modal__price-placeholder .bss-b2b-price-no-vat');
    if (!unitPriceEl) return;
    var productId = modal.querySelector('.quick-add-modal__price-placeholder') && modal.querySelector('.quick-add-modal__price-placeholder').getAttribute('data-product-id');
    var unitNum = parsePriceToNumber(unitPriceEl.textContent);
    recalcModalTotalsExclVat(modal, productId, unitNum);
  }, true);
})();
